/* Mitch Dowd PLP v1.2.1 (size grid, category pills, auto-apply, tighter top) - generated from mitchdowd-plp-size-grid.user.js (userscript header removed) */
/*
 * Theme: Impact (Maestrooo), live theme "Live Oct 2" - inspected 2026-10-03.
 *
 * Markup (Shopify native filtering, not Boost like jockey.com.au):
 *   details#accordion-filter-v-t-shopify-size
 *     .accordion__content > .checkbox-list > .checkbox-container
 *       input.checkbox[type=checkbox][name="filter.v.t.shopify.size"]
 *       label[for=...]  "S (180)"
 *
 * Behaviour this has to live with (all confirmed live):
 * - Filters sit in a left drawer (facet-drawer#facets-drawer) on desktop
 *   as well as mobile. Ticking a box only stages it; "Apply (n)" submits.
 * - Apply re-renders the whole section by AJAX: a brand-new drawer and
 *   size <details> are put in the page, and the theme also leaves the old
 *   drawer parked under <body> (so two size <details> share one id). We
 *   therefore process every matching <details> not yet marked, and watch
 *   the DOM for new ones.
 * - Size sets across the 57 nav collections: XS-4XL (adult), 6-14 (kids,
 *   e.g. boys-trunks, boys-pyjamas) and "One size" (socks). Only /all,
 *   gifts, sale, 25-off, 50-off, fam-jams, christmas, men and mens-new mix
 *   them; everywhere else it is one group, so no headers are shown.
 *
 * v1.1.0 adds two more parts (see the section comments further down):
 * - Category pills above the grid, read from the main nav (Men/Women/Kids/
 *   Gifts/Sale mega-menu columns). Re-added after each filter re-render,
 *   which replaces the whole section.
 * - Auto-apply: ticking a filter checkbox submits the theme's own facet form
 *   600ms after the last tick (the theme supports this natively via its
 *   update-on-change option, but this theme hard-codes it off). Confirmed in
 *   theme.js: FacetForm submits -> "facet:update" -> section re-render.
 */
(function () {
    'use strict';

    const SIZE_DETAILS = 'details[id*="filter-v-t-shopify-size"]';
    const ADULT = /^(XXS|XS|S|M|L|XL|\dXL)$/i;
    // Kids' sizes are plain numbers below 20 (today 6-14). Larger numbers,
    // e.g. a waist size like 32, fall through to "Other" instead.
    const KIDS = /^([1-9]|1\d)$/;
    const GROUPS = ['Adults', 'Kids', 'Other'];

    const CSS = `
        .mdsg-grid {
            display: grid !important;
            grid-template-columns: repeat(4, minmax(0, 1fr));
            gap: 8px;
            padding: 2px 2px 4px;
        }
        .mdsg-head {
            grid-column: 1 / -1;
            margin: 8px 0 0;
            font-size: 12px;
            font-weight: 700;
            letter-spacing: -0.2px;
            color: #9A9A9A;
        }
        .mdsg-head:first-child { margin-top: 0; }
        .mdsg-grid .checkbox-container {
            position: relative;
            display: flex !important;
            margin: 0 !important;
            padding: 0 !important;
        }
        .mdsg-grid .checkbox-container.mdsg-wide { grid-column: span 2; }
        /* Keep the real checkbox focusable for keyboard + screen readers,
           just out of sight - the label is the visible control. */
        .mdsg-grid input[type="checkbox"] {
            position: absolute !important;
            inset: 0;
            width: 100% !important;
            height: 100% !important;
            margin: 0 !important;
            opacity: 0 !important;
            pointer-events: none;
        }
        .mdsg-grid label {
            display: flex !important;
            align-items: center;
            justify-content: center;
            gap: 4px;
            width: 100%;
            min-height: 44px;
            padding: 4px 8px !important;
            margin: 0 !important;
            border: 1.5px solid #d6d6d6;
            border-radius: 50px;
            background: #fff;
            color: #1A1A1A;
            font-size: 14px;
            line-height: 1.1;
            letter-spacing: -0.4px;
            text-align: center;
            cursor: pointer;
            user-select: none;
            transition: border-color .15s, background-color .15s, color .15s;
        }
        .mdsg-grid label::before,
        .mdsg-grid label::after { display: none !important; }
        .mdsg-name { font-weight: 700; white-space: nowrap; }
        .mdsg-count { font-size: 11px; opacity: .6; }
        .mdsg-grid label:hover { border-color: #79158A; }
        .mdsg-grid input:checked + label {
            background: #79158A;
            border-color: #79158A;
            color: #fff;
        }
        .mdsg-grid input:checked + label .mdsg-count { opacity: .8; }
        .mdsg-grid input:focus-visible + label {
            outline: 2px solid #79158A;
            outline-offset: 2px;
        }
        .mdsg-grid input:disabled + label {
            opacity: .4;
            cursor: not-allowed;
            border-style: dashed;
        }
    `;

    function addStyle() {
        if (document.getElementById('mdsg-style')) return;
        const s = document.createElement('style');
        s.id = 'mdsg-style';
        s.textContent = CSS + PILL_CSS + TIGHT_CSS;
        (document.head || document.documentElement).appendChild(s);
    }

    function groupOf(name) {
        if (ADULT.test(name)) return 'Adults';
        if (KIDS.test(name)) return 'Kids';
        return 'Other';
    }

    function build(details) {
        const list = details.querySelector('.checkbox-list');
        if (!list || list.dataset.mdsg === '1') return;
        const items = Array.from(list.querySelectorAll(':scope > .checkbox-container'));
        if (!items.length) return;

        const groups = { Adults: [], Kids: [], Other: [] };
        items.forEach(item => {
            const label = item.querySelector('label');
            if (!label) return;
            // "S (180)" -> name "S", count "180". Rebuilt as two spans so the
            // count can be muted; the label keeps its for= link to the input.
            const raw = label.textContent.replace(/\s+/g, ' ').trim();
            const m = raw.match(/^(.*?)\s*\((\d+)\)$/);
            const name = m ? m[1] : raw;
            label.textContent = '';
            const n = document.createElement('span');
            n.className = 'mdsg-name';
            n.textContent = name;
            label.appendChild(n);
            if (m) {
                const c = document.createElement('span');
                c.className = 'mdsg-count';
                c.textContent = '(' + m[2] + ')';
                label.appendChild(c);
            }
            if (name.length > 4) item.classList.add('mdsg-wide');
            groups[groupOf(name)].push(item);
        });

        const used = GROUPS.filter(g => groups[g].length);
        list.textContent = '';
        used.forEach(g => {
            if (used.length > 1) {
                const h = document.createElement('p');
                h.className = 'mdsg-head';
                h.textContent = g;
                list.appendChild(h);
            }
            groups[g].forEach(item => list.appendChild(item));
        });
        list.classList.add('mdsg-grid');
        list.dataset.mdsg = '1';
    }

    // ---------- Category pills ----------
    // Sibling collections for the page you are on, read from the main nav so
    // they stay correct when the menu changes. Nav shape (confirmed live):
    //   nav.header__link-list > ul > li (Men / Women / Kids / Gifts / Sale)
    //     ul.mega-menu__nav > li (a column): a (heading) + ul > li > a (links)
    // The heading link is repeated as the first child link in most columns,
    // so links are de-duplicated by path.
    // No pills when the page is not in the nav, when it sits under more than
    // one top-level menu (e.g. fam-jams is under Men, Women and Kids, so we
    // cannot tell whose siblings to show), on /collections/all, or when the
    // column would give fewer than PILL_MIN pills.
    const PILL_MIN = 3;
    const PILL_MAX = 10;
    const PILL_CSS = `
        .mdpl {
            grid-column: 1 / -1;
            display: flex;
            flex-wrap: wrap;
            gap: 8px;
            margin: 0 0 20px;
        }
        .mdpl a.mdpl-pill {
            display: inline-flex;
            align-items: center;
            min-height: 40px;
            padding: 6px 16px;
            border: 1.5px solid #d6d6d6;
            border-radius: 50px;
            background: #fff;
            color: #1A1A1A;
            font-size: 14px;
            font-weight: 700;
            letter-spacing: -0.4px;
            line-height: 1.1;
            text-decoration: none;
            white-space: nowrap;
            transition: border-color .15s, background-color .15s, color .15s;
        }
        .mdpl a.mdpl-pill:hover { border-color: #79158A; }
        .mdpl a.mdpl-pill[aria-current="page"] {
            background: #79158A;
            border-color: #79158A;
            color: #fff;
        }
        .mdpl a.mdpl-pill:focus-visible { outline: 2px solid #79158A; outline-offset: 2px; }
        @media (max-width: 699px) {
            .mdpl { flex-wrap: nowrap; overflow-x: auto; padding-bottom: 4px; scrollbar-width: none; }
            .mdpl::-webkit-scrollbar { display: none; }
        }
    `;

    // ---------- Tighter top of page ----------
    // Trims a quarter of the empty space between the header and the first
    // product row on desktop (>= 700px; phone spacing not measured, so left
    // alone). Measured on /collections/mens-trunks at 1:1: banner margin 64px
    // above and below the title, 48px above the grid wrapper, and a 32px row
    // gap on the grid wrapper (between pills, filter bar and results).
    // Header bottom to first product row: 405px originally, 275px when every
    // gap was halved (v1.2.0, judged too tight), 340px now (half of that cut
    // put back).
    const TIGHT_CSS = `
        @media (min-width: 700px) {
            html.mdpl-tight .collection-header { margin-top: 48px; margin-bottom: 48px; }
            html.mdpl-tight .collection { margin-top: 36px; row-gap: 24px; }
            html.mdpl-tight .collection > .mdpl { margin-bottom: 15px; }
        }
    `;

    function pathOf(href) {
        try { return new URL(href, location.origin).pathname.replace(/\/+$/, '') || '/'; }
        catch (e) { return ''; }
    }

    function readNavColumns() {
        const nav = document.querySelector('header nav.header__link-list');
        if (!nav) return [];
        const label = a => a.textContent.trim().replace(/\s+/g, ' ');
        const cols = [];
        nav.querySelectorAll(':scope > ul > li').forEach((top, topIndex) => {
            top.querySelectorAll('ul.mega-menu__nav > li').forEach(col => {
                const head = col.querySelector(':scope > a');
                if (!head) return;
                cols.push({
                    topIndex,
                    head: { label: label(head), path: pathOf(head.href) },
                    links: Array.from(col.querySelectorAll(':scope > ul a'))
                        .map(a => ({ label: label(a), path: pathOf(a.href) }))
                });
            });
        });
        return cols;
    }

    function pillsFor(path) {
        if (!path.startsWith('/collections/') || path === '/collections/all') return null;
        const hits = readNavColumns().filter(c =>
            c.head.path === path || c.links.some(l => l.path === path));
        if (!hits.length) return null;
        if (new Set(hits.map(c => c.topIndex)).size > 1) return null;
        const col = hits.find(c => c.head.path === path) || hits[0];
        const seen = new Set();
        const pills = [];
        const add = (text, p) => {
            if (!p || seen.has(p)) return;
            seen.add(p);
            pills.push({ text, path: p });
        };
        add(/^all\b/i.test(col.head.label) ? col.head.label : 'All ' + col.head.label, col.head.path);
        col.links.forEach(l => add(l.label, l.path));
        return pills.length < PILL_MIN ? null : pills.slice(0, PILL_MAX);
    }

    function addPills() {
        const bar = document.querySelector('.collection > .collection__top-bar');
        if (!bar || bar.parentElement.querySelector(':scope > .mdpl')) return;
        const path = pathOf(location.href);
        const pills = pillsFor(path);
        if (!pills) return;
        const nav = document.createElement('nav');
        nav.className = 'mdpl';
        nav.setAttribute('aria-label', 'Shop by category');
        pills.forEach(p => {
            const a = document.createElement('a');
            a.className = 'mdpl-pill';
            a.href = p.path;
            a.textContent = p.text;
            if (p.path === path) a.setAttribute('aria-current', 'page');
            nav.appendChild(a);
        });
        bar.parentElement.insertBefore(nav, bar);
    }

    // ---------- Auto-apply ----------
    // Out of the box a tick only stages the filter and the shopper must press
    // "Apply (n)" (or close the drawer). The theme's FacetForm already
    // re-renders the results when its form is submitted, so we submit it for
    // them once they pause ticking. Checkboxes only: typing in the price
    // fields still waits for the shopper. The form that fires is the one the
    // shopper is ticking in (the theme leaves the opened drawer under <body>
    // across re-renders), so repeated ticks keep working.
    const APPLY_DELAY = 600;
    let applyTimer = 0;
    function onFilterChange(e) {
        const t = e.target;
        if (!(t instanceof HTMLInputElement) || t.type !== 'checkbox') return;
        const form = t.closest('form#facet-form');
        if (!form) return;
        clearTimeout(applyTimer);
        applyTimer = setTimeout(() => {
            if (!form.isConnected) return;
            if (form.requestSubmit) form.requestSubmit();
            else form.dispatchEvent(new Event('submit', { cancelable: true }));
        }, APPLY_DELAY);
    }

    // Each part can be switched off from the loader:
    //   window.MD_PLP = { grid: false, pills: false, autoApply: false, tight: false }
    const CFG = Object.assign({ grid: true, pills: true, autoApply: true, tight: true }, window.MD_PLP || {});

    function run() {
        if (CFG.grid) document.querySelectorAll(SIZE_DETAILS).forEach(build);
        if (CFG.pills) addPills();
        if (CFG.tight) document.documentElement.classList.toggle('mdpl-tight', !!document.querySelector('.collection'));
    }

    // Debounced observer with a circuit breaker (same pattern as the Jockey
    // PDP scripts): >100 runs in 2s means something is fighting us, so stop.
    let timer = 0;
    let runs = [];
    function schedule() {
        if (timer) return;
        timer = setTimeout(() => {
            timer = 0;
            const now = Date.now();
            runs = runs.filter(t => now - t < 2000);
            runs.push(now);
            if (runs.length > 100) {
                observer.disconnect();
                console.warn('[mdsg] observer disconnected (too many runs)');
                return;
            }
            run();
        }, 16);
    }
    const observer = new MutationObserver(schedule);

    function start() {
        addStyle();
        run();
        if (CFG.autoApply) document.addEventListener('change', onFilterChange);
        observer.observe(document.body, { childList: true, subtree: true });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', start);
    } else {
        start();
    }
})();
